import React from "react";

/**
 * Custom inline SVG brand icons for platforms not on simpleicons CDN
 * (or where we want a more reliable rendering).
 *
 * Each icon uses `currentColor` so it can be tinted via the parent's color.
 * All viewBoxes are 24x24 for consistency.
 */

export const AndroidTVIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    {/* Antennae */}
    <path d="M6.4 4.3a.55.55 0 0 1 .9-.6l1.6 2.4a8.8 8.8 0 0 1 6.2 0l1.6-2.4a.55.55 0 0 1 .9.6L16.1 6.6a8.6 8.6 0 0 1 3.9 7.1.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1-.5-.5 8.6 8.6 0 0 1 3.9-7.1L6.4 4.3Z" />
    <circle cx="9" cy="11" r="0.9" fill="#0a0e16" />
    <circle cx="15" cy="11" r="0.9" fill="#0a0e16" />
    {/* TV Frame around it */}
    <rect x="3" y="15.4" width="18" height="5.6" rx="0.9" fill="none" stroke="currentColor" strokeWidth="1.4" />
    <line x1="8" y1="22.4" x2="16" y2="22.4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const AmazonMusicIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    {/* circle bg */}
    <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.18" />
    {/* music note */}
    <path d="M10 7.2l7-1.4v8.6a2.4 2.4 0 1 1-1.6-2.27V8.6L11.6 9.36V15.2a2.4 2.4 0 1 1-1.6-2.27V7.2Z" />
    {/* amazon smile */}
    <path d="M6.8 17.4c1.6 1.2 3.4 1.7 5.2 1.7s3.6-.5 5.2-1.7" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M16.5 17l1 1-1 .2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export const AmazonFireTVIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    {/* flame */}
    <path d="M12 2c1.2 2 .5 4 -.3 5 .9-.4 2.6-.4 3.5 1 1.6 2.6 1.4 5.2 .1 7.1-1.7 2.4-4.8 2.7-7 .9-2.5-2.1-2.4-5.8-.4-7.7C9.5 7 11 6.9 11.5 8 11.5 5.6 11 4.4 12 2Z" />
    {/* inner highlight */}
    <path d="M12.4 11c.6 1 .3 2 -.4 2.6 .9-.1 1.7 .4 1.9 1.2 .3 1 -.4 2.1-1.4 2.4-1 .3-2.2-.3-2.4-1.4-.2-.8 .3-1.6 .9-1.9-.3-.7 0-1.6 .5-2.2 .3-.4 .7-.6 .9-.7Z" fill="#0a0e16" opacity="0.45" />
  </svg>
);

export const TCLIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <text
      x="12"
      y="16.5"
      textAnchor="middle"
      fontFamily="'Anton', 'Bebas Neue', Impact, sans-serif"
      fontSize="11"
      fontWeight="900"
      letterSpacing="0.6"
      fill="currentColor"
    >
      TCL
    </text>
    {/* underline accent */}
    <line x1="6" y1="19" x2="18" y2="19" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const PhilipsIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    {/* Shield */}
    <path d="M12 2 4.5 4.5v6c0 4.7 3 8.7 7.5 10.5 4.5-1.8 7.5-5.8 7.5-10.5v-6L12 2Z" fill="currentColor" opacity="0.2" stroke="currentColor" strokeWidth="1.2" />
    {/* Wave + 3 stars (Philips emblem inspired) */}
    <path d="M6.5 11.5c1.4-1 2.8 1 4.2 0 1.4-1 2.8 1 4.2 0" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <circle cx="8.5" cy="8" r="0.7" />
    <circle cx="12" cy="7.2" r="0.7" />
    <circle cx="15.5" cy="8" r="0.7" />
  </svg>
);

export const AmazonAppstoreIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    {/* 4-grid app icon */}
    <rect x="3.5" y="3.5" width="6.5" height="6.5" rx="1.4" />
    <rect x="14" y="3.5" width="6.5" height="6.5" rx="1.4" />
    <rect x="3.5" y="14" width="6.5" height="6.5" rx="1.4" />
    {/* Bottom-right: amazon smile */}
    <path d="M14 17.5c.9.7 1.9 1 3 1s2.1-.3 3-1" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M19.2 17.1l1 .6-.4 1" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

/**
 * Custom icon registry. Keys match the `customIcon` value in mock.js.
 */
export const CUSTOM_ICONS = {
  androidtv: AndroidTVIcon,
  amazonmusic: AmazonMusicIcon,
  amazonfiretv: AmazonFireTVIcon,
  tcl: TCLIcon,
  philips: PhilipsIcon,
  amazonappstore: AmazonAppstoreIcon,
};
